// import EnPNG from './img/en.png';
import EsPNG from './img/es.png';
import BrPNG from './img/br.png';

export const languages = {
  ES: 'es-es',
  // EN: 'en-US',
  PT: 'pt-BR',
};

export const languagesWithIcons = {
  'es-es': { lang: languages.ES, icon: EsPNG, text: 'Español' },
  'pt-BR': { lang: languages.PT, icon: BrPNG, text: 'Português' },
};

export const shortLanguages = {
  'es-es': 'es',
  'pt-BR': 'pt',
};
